/**
 * Password validation utility for frontend
 * Requirements:
 * - Minimum 8 characters
 * - At least 1 special character
 */

/**
 * Validates password strength
 * @param {string} password - Password to validate
 * @returns {Object} - { isValid: boolean, message: string }
 */
export const validatePassword = (password) => {
  if (!password) {
    return {
      isValid: false,
      message: "Password is required",
    };
  }

  // Minimum 8 characters
  if (password.length < 8) {
    return {
      isValid: false,
      message: "Password must be at least 8 characters long",
    };
  }

  // At least 1 special character (non-alphanumeric)
  const specialCharRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
  if (!specialCharRegex.test(password)) {
    return {
      isValid: false,
      message: "Password must contain at least 1 special character",
    };
  }

  return {
    isValid: true,
    message: "Password is valid",
  };
};

/**
 * Password regex pattern for validation
 * Matches: minimum 8 characters with at least 1 special character
 */
export const PASSWORD_REGEX = /^(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;
